import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import {
  Brand,
  Channel,
  GenericProvider,
  Platform,
  Provider,
  RGI,
} from '@/features/game-context/types';
import { RootState } from '@/store/store';

const initialState: GameContextState = {
  initialized: false,
  softInitialization: false,
  gameWindowUIEnabled: false,
};

const gameContextSlice = createSlice({
  name: 'gameContext',
  initialState,
  reducers: {
    setGameContext: (_, action: PayloadAction<GameContextState>) => ({
      ...action.payload,
    }),
    resetGameContext: (
      _,
      action: PayloadAction<{ softInitialization: boolean } | undefined>,
    ) => ({
      ...initialState,
      softInitialization: action.payload?.softInitialization ?? false,
    }),
    setGameWindowUIEnabled: (state, action: PayloadAction<boolean>) => ({
      ...state,
      gameWindowUIEnabled: action.payload,
    }),
  },
});

export const gameContextSelector = (state: RootState) => state.gameContext;
export const { setGameContext, resetGameContext, setGameWindowUIEnabled } =
  gameContextSlice.actions;

export const gameContextReducer = gameContextSlice.reducer;

export type VerifiedContextState = {
  rgi: RGI;
  brand: Brand;
  gameName: string;
  provider: string;
  providerRef: string;
  region: string;
  gameUid: string;
  userId: string;
};

export type GameContextState = {
  initialized: boolean;
  softInitialization?: boolean;
  gameWindowUIEnabled?: boolean;
  rgi?: RGI;
  brand?: Brand;
  gameName?: string;
  provider?: Provider | GenericProvider;
  gameStudio?: string;
  providerRef?: string;
  providerRefDesktop?: string;
  providerRefMobile?: string;
  region?: string;
  platform?: Platform;
  channel?: Channel;
  gameUid?: string;
  userId?: string;
  jackpotMode?: string;
  directLaunchParams?: Record<string, unknown>;
  iosVersion?: string;
  additionalConfigParams?: Record<string, string>;
};
